import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  FiGrid, FiUsers, FiMapPin, FiMail, FiBarChart2,
  FiFileText, FiMonitor, FiChevronLeft, FiChevronRight,
  FiArrowLeft, FiGlobe, FiTarget
} from 'react-icons/fi';
import './AdminSidebar.css';

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: FiGrid, exact: true },
  { path: '/admin/users', label: 'Users', icon: FiUsers },
  { path: '/admin/facilities', label: 'Facilities', icon: FiMapPin },
  { path: '/admin/subscribers', label: 'Subscribers', icon: FiMail },
  { path: '/admin/analytics', label: 'Analytics', icon: FiBarChart2 },
  { path: '/admin/web-source', label: 'Web Source', icon: FiGlobe },
  { path: '/admin/conversion-source', label: 'Conversion Source', icon: FiTarget },
  { path: '/admin/ads', label: 'Advertisements', icon: FiMonitor },
  { path: '/admin/blog', label: 'Blog Manager', icon: FiFileText },
];

const AdminSidebar = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path, exact) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      {/* Mobile toggle */}
      <button
        className="sidebar-mobile-toggle"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle sidebar"
      >
        {mobileOpen ? <FiChevronLeft /> : <FiChevronRight />}
      </button>

      <aside className={`admin-sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        {/* Sidebar header */}
        <div className="sidebar-header">
          {!collapsed && (
            <div className="sidebar-brand">
              <img src="/logo192.png" alt="MediGoMap" className="sidebar-logo" />
              <div className="sidebar-brand-text">
                <span className="sidebar-title">Admin Panel</span>
                <span className="sidebar-subtitle">{user?.name || 'Admin'}</span>
              </div>
            </div>
          )}
          <button
            className="sidebar-collapse-btn"
            onClick={() => setCollapsed(!collapsed)}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {navItems.map(item => {
            const active = isActive(item.path, item.exact);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-link ${active ? 'active' : ''}`}
                onClick={() => setMobileOpen(false)}
                title={collapsed ? item.label : undefined}
              >
                <item.icon className="sidebar-link-icon" />
                {!collapsed && <span className="sidebar-link-text">{item.label}</span>}
                {active && <div className="sidebar-active-indicator" />}
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <Link
            to="/"
            className="sidebar-link sidebar-back"
            title={collapsed ? 'Back to Site' : undefined}
          >
            <FiArrowLeft className="sidebar-link-icon" />
            {!collapsed && <span className="sidebar-link-text">Back to Site</span>}
          </Link>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
